<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-buy-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="t-sale"></div>
                <div class="dialog-body">
                    <div class="buy-detail">
                        <ul class="sale-list">
                            <li class="clearfix"><em class="f-l">商品总价</em><p class="f-r">{{ settle.total }}<em class="icon-m3b"></em></p></li>
                            <li class="clearfix"><em class="f-l">砍价已减</em><p class="f-r">{{ settle.share }}<em class="icon-m3b"></em></p></li>
                            <li v-if="settle.discount.type1 > 0" class="clearfix"><em class="f-l">每满2000b减200b满减</em><p class="f-r">{{ settle.discount.type1 }}<em class="icon-m3b"></em></p></li>
                            <li v-if="settle.discount.type2 > 0" class="clearfix"><em class="f-l">每满5000b减600b满减</em><p class="f-r">{{ settle.discount.type2 }}<em class="icon-m3b"></em></p></li>
                            <li v-if="settle.offer > 0" class="clearfix"><p class="f-l">店铺优惠券<em class="shop-ticket"></em></p><p class="f-r">{{ settle.offer }}<em class="icon-m3b"></em></p></li>
                        </ul>
                        <div class="total clearfix"><em class="f-l">合计</em><p class="f-r">{{ settle.bill }}<em class="icon-m3b"></em></p></div>
                        <div class="basket-list">
                            <ul v-if="list.length < 4">
                                <li v-for="(item,index) in list" :key="index">
                                    <div class="pic">
                                        <div class="item-pic"><game-item :id="item.itemid" :num="item.itemcount" :locked="true"></game-item></div>
                                        <!-- <img v-bind:src="item.img" v-bind:alt="item.name"> -->
                                    </div>
                                </li>
                            </ul>
                            <ul v-else>
                                <li v-for="(item,index) in list.slice(0,3)" :key="index">
                                    <div class="pic">
                                        <div class="item-pic"><game-item :id="item.itemid" :num="item.itemcount" :locked="true"></game-item></div>
                                        <!-- <img v-bind:src="item.img" v-bind:alt="item.name"> -->
                                    </div>
                                </li>                                
                            </ul>
                            <div class="cntor"><span v-if="list.length > 3">等</span>共{{ list.length }}件</div>
                        </div>
                        <button class="u-btn apply" @click="orderSubmit"></button>
                    </div>
                </div>          
            </div>         
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            settle : () => {},
            list : [],
            total_cnt : 0,
            m3b : 0,
        }
    },
    created (){
        this.total_cnt = this.list.length;
    },
    methods : {
        destroyElement () {
            //this.$destroy()
            //this.$el.parentNode.removeChild(this.$el)
            this.dialogVisible = false;
        },
        orderSubmit (){
            if(this.m3b < this.settle.bill)return this.$toast('梦三币不足~');
            //this.$emit('m3bUpdate_offline',this.m3b - this.settle.bill);

            if (this.settle.bill >= 3000 && this.$store.state.tjlSwitch == 'on') {
                //TODO TJL
            }
            else{
                this.$axios.post(this.$ajax_url_map.buy,this.$qs.stringify({
                    orderId: this.settle.orderId,
                    r : +new Date()                    
                }))
                .then(res => {
                    this.$toast('支付成功~');
                    this.$emit('m3bUpdate_offline',this.m3b - this.settle.bill);
                    this.$emit('render');
                    this.destroyElement();
                },rej => {
                    this.$toast(rej.message);
                });
            }           

            
        },     
    },       
}
</script>

<style scoped>
.m-buy-modal {
    min-width: 579px;
    height: 683px;
    background-image: url(~@/assets/images/utils/modal-buy.png);
    background-size: 100% 100%;
}

.t-buy {
    width: 293px;
    height: 54px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/utils/title-buy.png);
}

.m-buy-modal .buy-detail ul.sale-list {
    padding: 12px 24px 0;
    background-color: #e6bf85;
}

.m-buy-modal ul.sale-list li {
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px dashed #d7b078;
}

.buy-detail .total {
    padding: 12px 24px;
    margin-top: -12px;
    background-color: #dbb37b;
}

.m-buy-modal .basket-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 18px;
}

.basket-list ul{
    display: flex;
}

.basket-list .cntor {
    padding-right: 5px;
}

.m-buy-modal .u-btn.apply {
    position: absolute;
    left: 50%;
    bottom: 30px;
    width: 244px;
    height: 74px;
    margin: 35px auto 0;
    transform: translateX(-50%);
    background-image: url(~@/assets/images/utils/btn-buy.png);
}
</style>


// WEBPACK FOOTER //
// src/components/BuyModal/buyModal.vue